import React from 'react';
import withWrapper from '../withWrapper';
export default withWrapper('ViewList', function (props) {
  return React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    stroke: "none",
    strokeWidth: "4",
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("rect", {
    stroke: props.innerStrokeColor,
    strokeWidth: props.strokeWidth,
    fill: props.outFillColor,
    fillRule: "nonzero",
    strokeLinejoin: props.strokeLinejoin,
    x: "8",
    y: "4",
    width: "32",
    height: "40",
    rx: "4"
  }), React.createElement("path", {
    d: "M21,14 L33,14",
    stroke: props.innerStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), React.createElement("path", {
    d: "M21,24 L33,24",
    stroke: props.innerStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), React.createElement("path", {
    d: "M21,34 L33,34",
    stroke: props.innerStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), React.createElement("circle", {
    fill: props.innerStrokeColor,
    cx: "15",
    cy: "14",
    r: "2"
  }), React.createElement("circle", {
    fill: props.innerStrokeColor,
    cx: "15",
    cy: "24",
    r: "2"
  }), React.createElement("circle", {
    fill: props.innerStrokeColor,
    cx: "15",
    cy: "34",
    r: "2"
  })));
});